import Axios from "axios";
import { baseUrlDev } from "@/app.config.json";
import { baseUrl } from "../app.config";

export const appClient = Axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  headers: {
    Accept: "application/json",
    // "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json"
  },
  timeout: 30000
});

appClient.interceptors.request.use(config => {
  config.headers.Authorization = localStorage.token;
  return config;
});

appClient.interceptors.response.use(response => {
  return response;
});

export const apiClient = {
  appClient: appClient
};
